/**
 * Ed25519 signing helpers + hex utilities.
 *
 * The auth message formats below MUST stay in sync with the backend
 * (`backend/src/crypto/auth-message.ts`) and the public client
 * (`client/src/crypto/sign.ts`). Any divergence breaks staff auth.
 */

import { ed25519 } from "@noble/curves/ed25519.js";
import { bytesToHex, hexToBytes } from "@noble/hashes/utils.js";

const TEXT_ENCODER = new TextEncoder();

/** Sign a UTF-8 string or raw bytes with an Ed25519 secret key. */
export function sign(
  secretKey: Uint8Array,
  message: string | Uint8Array,
): Uint8Array {
  const msg =
    typeof message === "string" ? TEXT_ENCODER.encode(message) : message;
  return ed25519.sign(msg, secretKey);
}

export const hex = {
  fromBytes: bytesToHex,
  toBytes: hexToBytes,
};
